module.exports = __webpack_public_path__ + "static/media/kehi_din.952fc77c.ogg";